import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { AppActions } from 'store/actionCreators';

function NetworkStatusContainer() {
  useEffect(() => {
    const updateOnlineStatus = () => {
      AppActions.set_network_status(navigator.onLine ? 'online' : 'offline');
    };

    // 이벤트 리스너 등록
    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);

    // 클린업 함수로 이벤트 리스너 제거
    return () => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
    };
  }, []);

  return <></>;
}

export default NetworkStatusContainer;
